import apiCall from "../../axios";

export interface UnityTalkdownSupportCamera {
  cameraId: string;
  vendorCameraId?: string;
}

export interface UnityTalkdownSupportRequest {
  siteUniqueId: string;
  cameras: UnityTalkdownSupportCamera[];
}

export interface UnityTalkdownSupportResponse {
  cameraSupport?: Record<string, boolean>;
  success?: boolean;
  message?: string;
}

const getTalkdownCameraSpeakerSupport = async (
  body: UnityTalkdownSupportRequest
): Promise<UnityTalkdownSupportResponse> => {
  try {
    const response = await apiCall(
      "POST",
      "/avigilonunity/talkdown/camera-speaker-support",
      body
    );

    return (response.data?.data ?? response.data) as UnityTalkdownSupportResponse;
  } catch (error: any) {
    console.error("getTalkdownCameraSpeakerSupport (AvigilonUnity) Error:", error?.message);
    return {
      success: false,
      message: error?.message || "Failed to resolve Avigilon Unity talkdown camera support.",
      cameraSupport: {},
    };
  }
};

export default getTalkdownCameraSpeakerSupport;
